<template>
<!-- Start Blog Area
    ============================================= -->
    <div id="noticias" class="blog-area bg-gray default-padding bottom-less">
      <div class="container">
        <div class="heading-left">
          <div class="row">
            <div class="col-lg-5">
              <h2>Compartimos contigo noticias en tecnología y más.</h2>
            </div>
            <div class="col-lg-6 offset-lg-1">
              <p>
                Queremos mantenerte informado de acontecimientos de nuestro país
                más toda la información que necesitas saber para evitar sufrir
                ataques de cibercriminales.
              </p>
              <!--<a class="btn circle btn-md btn-gradient wow fadeInUp" href="#">View All <i class="fas fa-plus"></i></a>-->
            </div>
          </div>
        </div>
        <div class="blog-items">
          <div class="row">
            <!-- Single Item -->
            <div class="col-lg-4 col-md-6 single-item">
              <div class="item">
                <div class="thumb">
                  <a href="#">
                    <img src="assets/img/hacker.jpg" alt="Thumb" />
                    <div class="date">18 Junio <strong>2020</strong></div>
                  </a>
                </div>
                <div class="info">
                  <div class="meta">
                    <ul>
                      <li>
                        <i class="fas fa-folder-open"></i>
                      </li>
                      <li>
                        <a href="#">Datos</a>
                      </li>
                      <li>
                        <a href="#">Seguridad</a>
                      </li>
                    </ul>
                  </div>
                  <h4>
                    <a href="#">Ciberataques en Pandemia</a>
                  </h4>
                  <p>
                    En lo que llevamos del 2020 los ciberataques crecieron un
                    37% con respecto a todo el año 2019, los ciber ataques no
                    dan tregua y aprovechan los enuncios de gobierno para hacer
                    caes a los usuarios con bonos o postulaciones los cuales
                    infectan con virus espias que luego utilizan para robar
                    informacion
                  </p>
                  <a class="btn-simple" href="#"
                    ><i class="fas fa-angle-right"></i> Read More</a
                  >
                </div>
              </div>
            </div>
            <!-- End Single Item -->
            <!-- Single Item -->
            <div class="col-lg-4 col-md-6 single-item">
              <div class="item">
                <div class="thumb">
                  <a href="#">
                    <img
                      src="assets/img/img_160614_0314_ac05zr100_300dpi_800x300_3.jpg"
                      alt="Thumb"
                    />
                    <div class="date">02 Julio <strong>2020</strong></div>
                  </a>
                </div>
                <div class="info">
                  <div class="meta">
                    <ul>
                      <li>
                        <i class="fas fa-folder-open"></i>
                      </li>
                      <li>
                        <a href="#">Datos</a>
                      </li>
                      <li>
                        <a href="#">Seguridad</a>
                      </li>
                    </ul>
                  </div>
                  <h4>
                    <a href="#">Ransomware: como cuidarme </a>
                  </h4>
                  <p>
                    El ransomware es una forma muy conocida de software
                    malicioso que cifra los datos de un equipo para exigir
                    dinero. Si el usuario no le paga al cibercriminal en un
                    cierto plazo, no puede recuperar los datos y los pierde para
                    siempre. En este caso en particular, WannaCry exige un pago
                    de 300 USD en bitcoins.
                  </p>
                  <a
                    class="btn-simple"
                    :href="cons.links.referencias.nortonRansomware"
                    ><i class="fas fa-angle-right"></i> Leer más</a
                  >
                </div>
              </div>
            </div>
            <!-- End Single Item -->
            <!-- Single Item -->
            <div class="col-lg-4 col-md-6 single-item">
              <div class="item">
                <div class="thumb">
                  <a href="#">
                    <img src="assets/img/hero-img.png" alt="Thumb" />
                    <div class="date">28 Abril <strong>2020</strong></div>
                  </a>
                </div>
                <div class="info">
                  <div class="meta">
                    <ul>
                      <li>
                        <i class="fas fa-folder-open"></i>
                      </li>
                      <li>
                        <a href="#">Gobierno</a>
                      </li>
                      <li>
                        <a href="#">Plan económico</a>
                      </li>
                    </ul>
                  </div>
                  <h4>
                    <a href="#"
                      >Plan Económico de Emergencia por coronavirus.</a
                    >
                  </h4>
                  <p>
                    Este Plan del Gobierno de Chile busca entregar apoyo a los
                    trabajadores y trabajadoras, a las empresas y a las familias
                    más vulnerables del país para enfrentar las consecuencias
                    económicas derivadas de la crisis sanitaria por el virus
                    COVID-19.
                  </p>
                  <a
                    class="btn-simple"
                    :href="cons.links.referencias.gobPlanEconomico"
                    ><i class="fas fa-angle-right"></i> Leer más</a
                  >
                </div>
              </div>
            </div>
            <!-- End Single Item -->
          </div>
        </div>
      </div>
    </div>
    <!-- End Blog Area -->
</template>


<script>
    import cons from '@/utils/const';
    export default {
        name: "Banner4",
        components: {},
        data() {
            return { cons };
        },
        beforeMount() {},
    };
</script>